export const tenantApiBlackList = [
  'spp/projectInfo/list', //项目列表
]